import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Address } from 'src/app/shared/services/backend'
import { AddressMapper } from 'src/app/soft-login/mappers/AddressMapper'
import { InstallationItem } from '../../../models/installation-item.model'

export type CustomerRelationEntryMode = 'single' | 'radio'

@Component({
    selector: 'app-customer-relation-entry',
    templateUrl: './customer-relation-entry.component.html',
    styleUrls: ['./customer-relation-entry.component.scss'],
    standalone: false,
})
export class CustomerRelationEntryComponent {
    @Input() public installation!: InstallationItem
    @Input() public isBusiness = false
    @Input() public mode: CustomerRelationEntryMode = 'radio'
    @Input() public isSelected = false

    @Output() public select = new EventEmitter<InstallationItem>()

    public formatAddress(address: Address): string {
        return AddressMapper.formatAddress(address)
    }

    public showSingleAddress(): boolean {
        return (
            !!this.installation?.installations?.length &&
            this.installation.installations.length === 1 &&
            !!this.installation.installations[0].address
        )
    }

    public onRadioChange() {
        this.select.emit(this.installation)
    }

    public onInstallationSelected(installation: InstallationItem) {
        this.select.emit(installation)
    }
}
